var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.932,
    height: 15.054,
    viewBox: "0 0 29.932 15.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-624.664 -354.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_118",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 118",
    transform: "translate(625.164 354.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-airline-seat-recline-normal",
    "data-name": "Icon material-airline-seat-recline-normal",
    d: "M627.622,355.936a1.37,1.37,0,1,1,1.938,0A1.37,1.37,0,0,1,627.622,355.936Zm-2.458,2.687V364.1a3.424,3.424,0,0,0,3.424,3.424h3.424m3.618-1.13-2.979-2.979H630.3V360.9a6.525,6.525,0,0,0,2.885,1.366.73.73,0,0,0,.881-.709h0a.728.728,0,0,0-.623-.715,4.625,4.625,0,0,1-2.575-1.339l-.959-1.061a1.461,1.461,0,0,0-.473-.342,1.514,1.514,0,0,0-.657-.158h-.021a1.543,1.543,0,0,0-1.541,1.541v3.938a2.052,2.052,0,0,0,2.049,2.054h3.475l1.906,1.906a.7.7,0,0,0,.982,0h0A.694.694,0,0,0,635.63,366.4Z",
    transform: "translate(-625.164 -353.598)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_119",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 119",
    transform: "translate(643.426 354.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-airline-seat-recline-normal-2",
    "data-name": "Icon material-airline-seat-recline-normal",
    d: "M671.438,355.936a1.37,1.37,0,1,1,1.938,0A1.37,1.37,0,0,1,671.438,355.936Zm-2.452,11.589h3.424a3.424,3.424,0,0,0,3.424-3.424v-5.479m-10.466,8.754h0a.7.7,0,0,0,.982,0l1.906-1.906h3.475a2.052,2.052,0,0,0,2.049-2.054v-3.938a1.543,1.543,0,0,0-1.541-1.541h-.021a1.515,1.515,0,0,0-.657.158,1.461,1.461,0,0,0-.472.342l-.959,1.061a4.624,4.624,0,0,1-2.575,1.339.728.728,0,0,0-.623.715h0a.73.73,0,0,0,.881.709A6.525,6.525,0,0,0,670.7,360.9v2.52h-2.351l-2.979,2.979A.694.694,0,0,0,665.368,367.377Z",
    transform: "translate(-665.165 -353.598)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_120",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 120",
    transform: "translate(635.239 359.973)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_5",
    "data-name": "\\u7DDA 5",
    x2: 8.782,
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_6",
    "data-name": "\\u7DDA 6",
    y2: 5.586,
    transform: "translate(4.391 2.19)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconMeeting);
export default __webpack_public_path__ + "static/media/nav-icon-meeting.d8092c8ef597c6030aab3a928d44edf6.svg";
export { ForwardRef as ReactComponent };